import React from 'react';

import Box from '@opendoor/bricks/core/Box';
import Flex from '@opendoor/bricks/core/Flex';

import Grid, { gridStyles } from './Grid';
import { OpendoorLogoSVG } from './OpendoorLogoSVG';

const Header: React.FC = () => {
  return (
    <Grid maxWidth="unset" horizontalMargin={false}>
      <Box
        gridColumn={gridStyles.colSpan12}
        background="neutrals0"
        top={0}
        left={0}
        zIndex={8}
        width="100%"
      >
        <Flex
          px={gridStyles.margin}
          justifyContent="space-between"
          height={['56px', null, '80px']}
          alignItems="center"
        >
          <Box left={0} transform="none" position="absolute" display={['block']}>
            <OpendoorLogoSVG />
          </Box>
          <Flex flex={[null, null, 1]} justifyContent="flex-end" textAlign="right"></Flex>
        </Flex>
      </Box>
    </Grid>
  );
};

export default Header;
